// Single Chart.js registration point. Imported once at app boot.

import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  CategoryScale,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

export const TRAFFIC_PALETTE = [
  '#2a5a8c', '#06b6d4', '#16a34a', '#d1d5db', '#f59e0b',
  '#8b5cf6', '#ec4899', '#ef4444', '#84cc16', '#14b8a6',
];
